import { render, staticRenderFns } from "./PianiTerapeutici.vue?vue&type=template&id=af479262&"
import script from "./PianiTerapeutici.vue?vue&type=script&lang=js&"
export * from "./PianiTerapeutici.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports